module.exports = __webpack_public_path__ + "static/media/entryhall.lightvolume.7c34db17.obj";